module.exports = __webpack_public_path__ + "img/bluecor.5d72016f.png";